export default "__VITE_ASSET__xJ_sYjcw__"